
import React from 'react'
import { useParams } from "react-router-dom";
import { Box, Divider } from "@mui/material";

import { CustomerUserDetailContext } from "contexts/CustomerUserDetailContext";

import { useGetCustomerUserDataDetailQuery } from "store/services/customerUserApi";


import CustomerUserBasicDetail from "./customerComponents/CustomerUserBasicDetails";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { CustomerTab } from "./customerComponents/CustomerProfileTab";
import { useAppMeta, useAuth } from "hooks";
import UserAccess from "components/User/UserAccess";

const CustomerUserDetailScreen = () => {

  const { isAccountAdmin, isSystemAdmin } = useAuth();

  const { id } = useParams();

  const breadcrumbs = [
    { title: "Customer", path: "/app/crm/customerUser/list" },
    { title: "Customer Detail" },
  ];

  // RTK Query
  const {
    data: customerUserDetail,
    isLoading: loadingUserCustomer,
    error,
  } = useGetCustomerUserDataDetailQuery(id);

  const PageActions = () => (
    <>
      {(isAccountAdmin || isSystemAdmin) && (
        <Box display="flex" alignItems="center" gap={2}>
          {(customerUserDetail?.email && <UserAccess sourceDetail={customerUserDetail} typeRefSource={"Customer"} />
          )}
          {/* <Link to={`/app/crm/customerUser/${id}/edit`} state={{ from: "detail" }}>
        <Button variant="contained" startIcon={<EditOutlined />}>
          Edit
        </Button>
      </Link> */}
        </Box>)}
    </>
  );

  //Tabs

  useAppMeta("Customer Detail");
  return (
    <CustomerUserDetailContext.Provider value={{ customerUserDetail, loadingUserCustomer }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingUserCustomer}
        headerActions={<PageActions />} >

        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <CustomerUserBasicDetail />

          <Divider />
          <CustomerTab />


        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>

    </CustomerUserDetailContext.Provider>
  );
}

export default CustomerUserDetailScreen;
